import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../utils/api';

// Query Keys
export const setUpQueryKeys = {
  all: ['setUp'],
  list: () => [...setUpQueryKeys.all, 'list'],
};

// ==================== 설정 목록 조회 ====================
/**
 * 설정 목록 조회
 */
export const useSetUpList = () => {
  return useQuery({
    queryKey: setUpQueryKeys.list(),
    queryFn: async () => {
      const response = await api.get('/drivecore/setup/api/Setup');
      return response;
    },
  });
};

// ==================== 설정 추가 ====================
/**
 * 설정 추가
 * @param {Object} payload - 추가할 설정 데이터
 * @param {string} payload.group - 설정 그룹
 * @param {string} payload.key - 설정 키
 * @param {string} payload.valueType - 설정 값 타입 (String, Number, Boolean, Object)
 * @param {string} payload.description - 설정 설명
 */
export const useCreateSetUp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const response = await api.post('/drivecore/setup/api/Setup', payload);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: setUpQueryKeys.list() });
    },
  });
};

// ==================== 설정 수정 ====================
/**
 * 설정 수정
 * @param {Object} payload - 수정할 설정 데이터
 * @param {string} payload.group - 설정 그룹
 * @param {string} payload.key - 설정 키
 * @param {string} payload.value - 설정 값
 * @param {string} payload.updatedBy - 수정자(사용자 시스템 ID)
 */
export const useUpdateSetUp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const response = await api.put('/drivecore/setup/api/Setup', payload);
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: setUpQueryKeys.list() });
    },
  });
};


// ==================== 설정 삭제 ====================
/**
 * 설정 수정
 * @param {Object} payload - 수정할 설정 데이터
 * @param {string} payload.group - 설정 그룹
 * @param {string} payload.key - 설정 키
 * @param {string} payload.value - 설정 값
 * @param {string} payload.updatedBy - 수정자(사용자 시스템 ID)
 */
export const useDeleteSetUp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const response = await api.delete(`/drivecore/setup/api/Setup`, { data: payload });
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: setUpQueryKeys.list() });
    },
  });
};